import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ButtonDiv } from '@components/ConsentOverlay/ConsentOverlay.style';
import Icon from '@components/Icon/Icon';
import RoundedButton from '@components/RoundedButton';

import { DEVICES } from '@constants/routes';

import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  title: {
    defaultMessage:
      'Hello {name}, you currently have smart health and wearable device(s) connected to your VITALL profile. We have replaced the service that enables these connections with a new service that will serve you and all of our clients better. You will need to reconnect your smart health and wearable device(s).',
    id: 'terraForm.title',
  },
  buttonText: {
    id: 'terraForm.buttonText',
    defaultMessage: 'Reconnect my health device(s)',
  },
  questions: {
    id: 'terraForm.questions',
    defaultMessage:
      'If you have any questions, please reach out to support@vitall.com.',
  },
});

export default function TerraModalContent({
  onClose,
}: {
  onClose?: () => void;
}) {
  const { formatMessage } = useIntl();
  const handleClose = () => onClose?.();

  const {
    state: { activeProfile },
  } = useSession();

  return (
    <Card>
      <CardHeader
        action={
          <Icon name="xmark" onClick={handleClose} size="lg" type="fas" />
        }
      />
      <CardContent>
        <Typography
          sx={{
            fontSize: '20px',
            margin: '0px 5% 15px',
          }}
        >
          {formatMessage(messages.title, {
            name: activeProfile?.first_name,
          })}
        </Typography>
        <ButtonDiv>
          <RoundedButton
            onClick={() => {
              navigate(DEVICES);
              handleClose();
            }}
            width="250px"
          >
            {formatMessage(messages.buttonText)}
          </RoundedButton>
          <Typography
            sx={{
              fontSize: '18px',
              margin: '15px',
            }}
          >
            {formatMessage(messages.questions)}
          </Typography>
        </ButtonDiv>
      </CardContent>
    </Card>
  );
}
